import Log from './log'
import Review from './review'

export default {
  props: ['companyId', 'id' , 'reviewable'],
  data(){
    return {
      commmitId:null,
      target:[],
      origin:[]
    }
  },
  created(){
    this.query()
  },
  methods:{
    query(){
      let promise
      if( this.companyId ){
        promise = this.$request.companyLastCommit(this.companyId )
      }else if( this.id ){
        promise = this.$request.companyCommit(this.id )
      }
      if( promise ){
        promise.then(resp => {
          if( resp.code ){

          }else{
            this.commmitId = resp.data.id
            this.target = this.conv( resp.data.targetCompany || {})
            this.origin = this.conv( resp.data.originalCompany || {})
          }
        })
      }
    },

    conv(data){
      data = this.$utils.conv(data , {'establishDatetime':'date' , 'companyType':'companyType' , 'companyNature':'companyNature','runType':'runType','areaLabel':'area'})
      if (data.latitude && data.longitude) {
        data.location = [data.longitude , data.latitude]
        data.locationLabel = data.longitude +','+ data.latitude
      }

      if( data.files ){
        for(let fileType of new Set(data.files.map(i => i.fileType))){
          data['photo'+ fileType] = data.files.filter(i => i.fileType == fileType).map(i => i.filePath).sort().join(';')
        }
      }
      console.log(data)
      return data
    },
    review(){
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review id={this.commmitId} />
        },
        onOk: () => {
          // this.query()
          this.$emit('ok' , true)
        }
      })
    },
    diff(key){
      let { target = {} , origin = {} } = this
      if( target[key] !== origin[key] ){
        return { color:'#fa795e'}
      }else{
        return {}
      }
    },
  },
  render() {
    const diff = this.diff
    const data = this.target || {}

    const footer = this.reviewable ? <div class="modal-footer">
          <Button on-click={this.review} type="primary">审核</Button>
        </div> : null
    return (
      <div>
        <div class="modal-body">
          <sl-detail-list layout="vertical" label-width="150px" col={4} label-align="right">
            <sl-detail-list-item labelStyle={diff('companyName')} title="企业名称" content={data.companyName}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('unionCreditCode')} title="统一信用代码" content={data.unionCreditCode}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('shortName')} title="企业简称" content={data.shortName}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('parentId')} title="上家企业" content={data.parentName}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('runType')} title="运营方式" content={data.runTypeText} />
            <sl-detail-list-item labelStyle={diff('companyType')} title="企业类型" content={data.companyTypeText}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('companyNature')} title="企业性质" content={data.companyNatureText}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('legalName')} title="负责人" content={data.legalName}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('companyPhone')} title="联系方式" content={data.companyPhone}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('storageCount')} title="存量车整改数量" content={data.storageCount} />

            <sl-detail-list-item labelStyle={diff('brandId')} title="品牌" content={data.brandName}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('areaLabel')} title="所属区域" content={data.areaLabel}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('establishDatetime')} title="成立时间" content={data.establishDatetimeText}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('regAddress')} title="注册地址" content={data.regAddress}>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('businessAddress')} title="所在地址" content={data.businessAddress}>
            </sl-detail-list-item>


            <sl-detail-list-item labelStyle={diff('photo21')} label="网点照片">
              <sl-carousel width="150px" images={data.photo21 ? data.photo21.split(';') : []} public={true} />
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('photo22')} label="备案申请表">
              <sl-img width="150px"src={data.photo22} public={true} />
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('photo23')} label="营业执照">
              <sl-img width="150px" src={data.photo23} public={true} />
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('photo24')} label="法人身份证正面">
              <sl-img width="150px" src={data.photo24} public={true} />
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('photo25')}label="法人身份证背面">
              <sl-img width="150px" src={data.photo25} public={true} />
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('photo26')} label="快递经营许可证">
              <sl-img width="150px" src={data.photo26} public={true} />
            </sl-detail-list-item>
          </sl-detail-list>
          <sl-detail-list layout="vertical" label-width="150px" col={1} >
            <sl-detail-list-item labelStyle={diff('locationLabel')} title="地理位置">
              <sl-amap style="height:300px;">
                <sl-amap-marker center={data.location} cs="wgs84" />
              </sl-amap>
            </sl-detail-list-item>
            <sl-detail-list-item labelStyle={diff('remark')} title="备注" content={data.remark}>
            </sl-detail-list-item>
          </sl-detail-list>
        </div>
        { footer } 
      </div>
    )
  }
}
